import React from "react";
import { cropr, gettext } from "../../adapter";
import { ReactComponent as DropIcon } from "./../../images/svg/drop.svg";
import { useLocation, useRouteMatch, Link } from "react-router-dom";
import { Map as LeafletMap, Marker, Popup, TileLayer } from "react-leaflet";
import { iconSwitch } from "./../../utils/mapUtils";

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

const statusSwitch = (sensor) => {
  var status = <p>-</p>;
  if (sensor.status === "new") {
    status = (
      <p>
        <DropIcon class="icon text-gray is-inline" />
        <span>{gettext("Not yet configured")}</span>
      </p>
    );
  } else if (sensor.period === "past") {
    status = (
      <p>
        <DropIcon class="icon text-gray is-inline" />
        <span>{gettext("Not yet configured")}</span>
      </p>
    );
  } else if (sensor.period === "future") {
    status = (
      <p>
        <DropIcon class="icon text-gray is-inline" />
        <span>{gettext("Measurement period in the future")}</span>
      </p>
    );
  } else if (sensor.status === "onNoData") {
    status = (
      <p>
        <DropIcon class="icon text-gray is-inline" />
        <span>{gettext("No recent measurements")}</span>
      </p>
    );
  } else if (sensor.soilMoistureStatus === "aboveFieldCapacity") {
    status = (
      <p>
        <DropIcon class="icon text-blue is-inline" />
        <span>{gettext("Above field capacity")}</span>
      </p>
    );
  } else if (sensor.soilMoistureStatus === "belowRefillPoint") {
    status = (
      <p>
        <DropIcon class="icon text-red is-inline" />
        <span>{gettext("Below refill point")}</span>
      </p>
    );
  } else if (sensor.soilMoistureStatus === "belowWarningPoint") {
    status = (
      <p>
        <DropIcon class="icon text-yellow is-inline" />
        <span>{gettext("Below warning point")}</span>
      </p>
    );
  } else if (sensor.soilMoistureStatus === "normal") {
    status = (
      <p>
        <DropIcon class="icon text-green is-inline" />
        <span>{gettext("Normal moisture status")}</span>
      </p>
    );
  }
  return status;
};

const formatRefillCapacity = (sensor) => {
  var refillCapacity = "-";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    (sensor.refillCapacity || sensor.refillCapacity === 0)
  ) {
    refillCapacity =
      cropr.l10n_utils.mm_to_l10n(round(sensor.refillCapacity, 0)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }
  return refillCapacity;
};

const formatSoilMoisture = (sensor) => {
  var soilMoisture = "-";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    (sensor.soilMoisture || sensor.soilMoisture === 0)
  ) {
    soilMoisture =
      cropr.l10n_utils.mm_to_l10n(round(sensor.soilMoisture, 0)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }
  return soilMoisture;
};

const Map = ({ className, sensors }) => {
  const location = useLocation();
  const match = useRouteMatch();

  // @TODO migrate: add cropr fields to map
  //   // Add fields to the map
  //   if (Wkt) {
  //     var wkt = new Wkt.Wkt();
  //     cropr.cropfields.each(function (feature) {
  //       if (feature.get("geometry")) {
  //         wkt.read(feature.get("geometry"));
  //         wkt.toObject(feature.get("style")).addTo(mapRef.current);
  //       }
  //     });
  //   }

  let bounds = sensors.map(function (sensor) {
    return [sensor.latitude, sensor.longitude];
  });

  if (bounds.length < 1) bounds = null;

  return (
    <LeafletMap
      bounds={bounds}
      id="map"
      className={className}
      zoom={16}
      boundsOptions={{ padding: [5, 5] }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      {sensors.map((sensor) => {
        return (
          <Marker
            key={sensor.id}
            icon={iconSwitch(sensor)}
            position={[sensor.latitude, sensor.longitude]}
          >
            <Popup>
              <Link
                to={
                  sensor.status === "new"
                    ? match.path + "/" + sensor.id + "/edit" + location.search
                    : match.path + "/" + sensor.id + "/detail" + location.search
                }
              >
                <h4>{sensor.name}</h4>
              </Link>
              <strong>{sensor.type.charAt(0).toUpperCase() + sensor.type.slice(1)}</strong>
              {statusSwitch(sensor)}
              <p>
                {gettext("Available soil moisture")}: <em>{formatSoilMoisture(sensor)}</em>
                <br />
                {gettext("Refill capacity")}: <em>{formatRefillCapacity(sensor)}</em>
              </p>
            </Popup>
          </Marker>
        );
      })}
    </LeafletMap>
  );
};

export default Map;
